import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getRequest } from 'modules/request';
import { DYNAMIC_CONTENT_REVALIDATION_TIME } from 'constants';
import { EmptyLayout } from 'components/ant/layouts';
import { Card } from 'components/ant/ui/Card';

const Page = ({ listing }) => (
  <EmptyLayout>
    <Card item={listing} />
  </EmptyLayout>
);

export const getStaticProps = async (ctx) => {
  try {
    const listing = await getRequest()
      .get(`/listings/${ctx.params.slug}`)
      .then((res) => res.body);

    return {
      props: {
        listing,
        ...(await serverSideTranslations(ctx.locale, ['common'])),
      },
      revalidate: DYNAMIC_CONTENT_REVALIDATION_TIME,
    };
  } catch (err) {
    return {
        notFound: true,
    }
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export default Page;
